import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; // Adjust the API instance import as per your setup
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const EditHsnCode = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editHSNcode, setEDitHsncode] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const authToken = localStorage.getItem("authToken");

  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  const location = useLocation();

  const { data } = location.state || {};
  console.log(data, "hsncodeDATa");

  const fetchHSNCode = async () => {
    try {
      const response = await axiosInstance.get(
        `/hsncode/edit/${data.hsncode_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const fetchedData = response.data.data;
      const formatedData = {
        hsncode: fetchedData.hsncode,
        hsncode_desc: fetchedData.hsncode_desc,
        status: fetchedData.status === 1 ? true : false,
      };
      setFormData(formatedData);
      setEDitHsncode(fetchedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHSNCode();
  }, []);

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    HSNInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    try {
      // Prepare payload
      const payload = {
        hsncode: formData.hsncode,
        hsncode_desc: formData.hsncode_desc,
        status: formData.status === true ? 1 : 0,
      };

      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this HSN Code?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (confirmation.isConfirmed) {
        setLoading(true);
        await axiosInstance.patch(
          `/hsncode/update/${data.hsncode_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        await Swal.fire({
          title: "Success",
          text: "HSN Code updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        navigate("/admin/manage-logistic/hsn-code");
      }
    } catch (error) {
      console.error("Error updating HSN Code:", error);

      // Error handling with Swal.fire
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while updating the HSN Code.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate("/admin/manage-logistic/hsn-code");
  };

  const HSNInputs = [
    {
      name: "hsncode",
      label: "HSN",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.hsnName({ required: true }),
      disabled: true,
    },
    {
      name: "hsncode_desc",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];
  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={backNavigate}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit HSN Code</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Update the HSN Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={HSNInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(HSNInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  HSNInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditHsnCode;
